export default __webpack_public_path__ + "static/media/case_study_1.31fc94ef.jpg";